export enum FeeType {
    Fixed = 1,
    Percentage,
    DemandSurcharge
}
